(function () {
  Flint.file("views/pages/emrPage.js", function (require) {
    Flint.staticStyles("EmrPage", {
      "$emrPage": "#_flintapp emrPage.EmrPage, #_flintapp .EmrPage.emrPage, #_flintapp .ViewEmrPage.emrPage, #_flintapp .EmrPage > .emrPage",
      "$enchantLogo": "#_flintapp enchantLogo.EmrPage, #_flintapp .EmrPage.enchantLogo, #_flintapp .ViewEmrPage.enchantLogo, #_flintapp .EmrPage > .enchantLogo",
      "$page": "#_flintapp page.EmrPage, #_flintapp .EmrPage.page, #_flintapp .ViewEmrPage.page, #_flintapp .EmrPage > .page",
      "$header": "#_flintapp header.EmrPage, #_flintapp .EmrPage.header, #_flintapp .ViewEmrPage.header, #_flintapp .EmrPage > .header",
      "$headerTopLine": "#_flintapp headerTopLine.EmrPage, #_flintapp .EmrPage.headerTopLine, #_flintapp .ViewEmrPage.headerTopLine, #_flintapp .EmrPage > .headerTopLine",
      "$headerBottomLine": "#_flintapp headerBottomLine.EmrPage, #_flintapp .EmrPage.headerBottomLine, #_flintapp .ViewEmrPage.headerBottomLine, #_flintapp .EmrPage > .headerBottomLine",
      "$headerNormSize": "#_flintapp headerNormSize.EmrPage, #_flintapp .EmrPage.headerNormSize, #_flintapp .ViewEmrPage.headerNormSize, #_flintapp .EmrPage > .headerNormSize",
      "$big": "#_flintapp big.EmrPage, #_flintapp .EmrPage.big, #_flintapp .ViewEmrPage.big, #_flintapp .EmrPage > .big",
      "$squiggle": "#_flintapp squiggle.EmrPage, #_flintapp .EmrPage.squiggle, #_flintapp .ViewEmrPage.squiggle, #_flintapp .EmrPage > .squiggle",
      "$mainPitch": "#_flintapp mainPitch.EmrPage, #_flintapp .EmrPage.mainPitch, #_flintapp .ViewEmrPage.mainPitch, #_flintapp .EmrPage > .mainPitch",
      "$emrBookImg": "#_flintapp emrBookImg.EmrPage, #_flintapp .EmrPage.emrBookImg, #_flintapp .ViewEmrPage.emrBookImg, #_flintapp .EmrPage > .emrBookImg",
      "$listHeading": "#_flintapp listHeading.EmrPage, #_flintapp .EmrPage.listHeading, #_flintapp .ViewEmrPage.listHeading, #_flintapp .EmrPage > .listHeading",
      "$ul": "#_flintapp ul.EmrPage, #_flintapp .EmrPage.ul, #_flintapp .ViewEmrPage.ul, #_flintapp .EmrPage > .ul",
      "$white": "#_flintapp white.EmrPage, #_flintapp .EmrPage.white, #_flintapp .ViewEmrPage.white, #_flintapp .EmrPage > .white",
      "$rightSection": "#_flintapp rightSection.EmrPage, #_flintapp .EmrPage.rightSection, #_flintapp .ViewEmrPage.rightSection, #_flintapp .EmrPage > .rightSection",
      "$goButton": "#_flintapp goButton.EmrPage, #_flintapp .EmrPage.goButton, #_flintapp .ViewEmrPage.goButton, #_flintapp .EmrPage > .goButton",
      "$osHeadline": "#_flintapp osHeadline.EmrPage, #_flintapp .EmrPage.osHeadline, #_flintapp .ViewEmrPage.osHeadline, #_flintapp .EmrPage > .osHeadline",
      "$squiggletwo": "#_flintapp squiggletwo.EmrPage, #_flintapp .EmrPage.squiggletwo, #_flintapp .ViewEmrPage.squiggletwo, #_flintapp .EmrPage > .squiggletwo",
      "$offerPitch": "#_flintapp offerPitch.EmrPage, #_flintapp .EmrPage.offerPitch, #_flintapp .ViewEmrPage.offerPitch, #_flintapp .EmrPage > .offerPitch",
      "$opTopLine": "#_flintapp opTopLine.EmrPage, #_flintapp .EmrPage.opTopLine, #_flintapp .ViewEmrPage.opTopLine, #_flintapp .EmrPage > .opTopLine",
      "$opBottomLine": "#_flintapp opBottomLine.EmrPage, #_flintapp .EmrPage.opBottomLine, #_flintapp .ViewEmrPage.opBottomLine, #_flintapp .EmrPage > .opBottomLine",
      "$squigglethree": "#_flintapp squigglethree.EmrPage, #_flintapp .EmrPage.squigglethree, #_flintapp .ViewEmrPage.squigglethree, #_flintapp .EmrPage > .squigglethree",
      "$opNormSize": "#_flintapp opNormSize.EmrPage, #_flintapp .EmrPage.opNormSize, #_flintapp .ViewEmrPage.opNormSize, #_flintapp .EmrPage > .opNormSize",
      "$free": "#_flintapp free.EmrPage, #_flintapp .EmrPage.free, #_flintapp .ViewEmrPage.free, #_flintapp .EmrPage > .free",
      "$bonusBooksSection": "#_flintapp bonusBooksSection.EmrPage, #_flintapp .EmrPage.bonusBooksSection, #_flintapp .ViewEmrPage.bonusBooksSection, #_flintapp .EmrPage > .bonusBooksSection",
      "$bonusBook": "#_flintapp bonusBook.EmrPage, #_flintapp .EmrPage.bonusBook, #_flintapp .ViewEmrPage.bonusBook, #_flintapp .EmrPage > .bonusBook",
      "$bonusBookImg": "#_flintapp bonusBookImg.EmrPage, #_flintapp .EmrPage.bonusBookImg, #_flintapp .ViewEmrPage.bonusBookImg, #_flintapp .EmrPage > .bonusBookImg",
      "$bonusBookInfo": "#_flintapp bonusBookInfo.EmrPage, #_flintapp .EmrPage.bonusBookInfo, #_flintapp .ViewEmrPage.bonusBookInfo, #_flintapp .EmrPage > .bonusBookInfo",
      "$bonusBookTitle": "#_flintapp bonusBookTitle.EmrPage, #_flintapp .EmrPage.bonusBookTitle, #_flintapp .ViewEmrPage.bonusBookTitle, #_flintapp .EmrPage > .bonusBookTitle",
      "$bonusBookDescription": "#_flintapp bonusBookDescription.EmrPage, #_flintapp .EmrPage.bonusBookDescription, #_flintapp .ViewEmrPage.bonusBookDescription, #_flintapp .EmrPage > .bonusBookDescription",
      "$bottomSection": "#_flintapp bottomSection.EmrPage, #_flintapp .EmrPage.bottomSection, #_flintapp .ViewEmrPage.bottomSection, #_flintapp .EmrPage > .bottomSection",
      "$bsHeadline": "#_flintapp bsHeadline.EmrPage, #_flintapp .EmrPage.bsHeadline, #_flintapp .ViewEmrPage.bsHeadline, #_flintapp .EmrPage > .bsHeadline",
      "$bookAll": "#_flintapp bookAll.EmrPage, #_flintapp .EmrPage.bookAll, #_flintapp .ViewEmrPage.bookAll, #_flintapp .EmrPage > .bookAll",
      "$goButtonOne": "#_flintapp goButtonOne.EmrPage, #_flintapp .EmrPage.goButtonOne, #_flintapp .ViewEmrPage.goButtonOne, #_flintapp .EmrPage > .goButtonOne",
      "$goButtonTwo": "#_flintapp goButtonTwo.EmrPage, #_flintapp .EmrPage.goButtonTwo, #_flintapp .ViewEmrPage.goButtonTwo, #_flintapp .EmrPage > .goButtonTwo"
    }, {
      "$emrPage": {
        alignItems: 'center',
        color: 'white'
      },
      "$enchantLogo": {},
      "$page": {
        padding: [15, 60, 15],

        alignItems: 'center',
        fontFamily: 'helvetica neue'
      },
      "$header": {
        alignItems: 'center',
        width: '100%',

        lineHeight: 1.6
      },
      "$headerTopLine": {},
      "$headerBottomLine": {
        flexDirection: 'row'
      },
      "$headerNormSize": {
        whiteSpace: 'nowrap'
      },
      "$big": {
        flexDirection: 'column',

        textAlign: 'center',
        lineHeight: .7
      },
      "$squiggle": {},
      "$mainPitch": {
        justifyContent: 'flex-start',

        paddingTop: 10
      },
      "$emrBookImg": {
        marginTop: 15
      },
      "$listHeading": {
        fontStyle: 'italic'
      },
      "$ul": {
        color: 'rgb(253, 172, 223)'
      },
      "$white": {
        color: 'white',
        display: 'inline-block'
      },
      "$rightSection": {
        flexDirection: 'column',
        alignItems: 'center'
      },
      "$goButton": {
        border: '5px solid rgb(112, 40, 91)',
        borderRadius: 10,

        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'white'
      },
      "$osHeadline": {
        flexDirection: 'row',
        alignSelf: 'center'
      },
      "$squiggletwo": {
        alignSelf: 'center'
      },
      "$offerPitch": {
        justifyContent: 'center',
        alignItems: 'center',

        lineHeight: 1.8
      },
      "$opTopLine": {
        flexDirection: 'row'
      },
      "$opBottomLine": {
        flexDirection: 'row'
      },
      "$squigglethree": {},
      "$opNormSize": {
        whiteSpace: 'nowrap'
      },
      "$free": {
        lineHeight: 1,

        alignItems: 'center'
      },
      "$bonusBooksSection": {
        width: '80%',
        marginTop: 20
      },
      "$bonusBook": {},
      "$bonusBookImg": {},
      "$bonusBookInfo": {
        flexDirection: 'column',
        alignSelf: 'center'
      },
      "$bonusBookTitle": {
        fontWeight: 'bold',
        paddingBottom: 15
      },
      "$bonusBookDescription": {
        flexDirection: 'column',

        width: 300,
        paddingRight: 8,
        paddingLeft: 8
      },
      "$bottomSection": {
        width: '100%',
        marginTop: 25
      },
      "$bsHeadline": {
        alignSelf: 'center',
        paddingBottom: 25,

        display: 'inline-block',
        textAlign: 'center'
      },
      "$bookAll": {
        alignSelf: 'center'
      },
      "$goButtonOne": {
        border: '5px solid rgb(112, 40, 91)',
        borderRadius: 10,

        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'white',
        alignSelf: 'center'
      },
      "$goButtonTwo": {
        border: '5px solid rgb(112, 40, 91)',
        borderRadius: 10,

        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: 'white',
        alignSelf: 'center'
      }
    });
    Flint.view("EmrPage", function (view, on, $) {
      var context = initContext(view, {
        width: atom(),
        isMobile: atom()
      });

      on.mount(function () {
        M.mixpanel.track("PageView", { page: 'enchant-mr-right' });
      });

      var buttonOneHover = atom(false);
      var buttonTwoHover = atom(false);view.render(function () {
        return view.el(["NavBar", 1], null);
      });view.render(function () {
        return view.el(
          ["emrPage", 1],
          null,
          view.el(["img", 1], { className: "enchantLogo", src: "/images/enchant-mr-right/emr-logo.png" }),
          view.el(
            ["page", 1],
            null,
            view.el(
              ["header", 1],
              null,
              view.el(
                ["headerTopLine", 1],
                null,
                view.el(
                  ["headerNormSize", 1],
                  null,
                  "A girl's essential reading to get the guy she"
                ),
                Flint.iff(!context.isMobile.get()) && view.el(
                  ["big", 1],
                  { if: !context.isMobile.get() },
                  "wants",
                  view.el(["img", 2], { className: "squiggle", src: "/images/enchant-mr-right/squiggle.png" })
                )
              ),
              view.el(
                ["headerBottomLine", 1],
                null,
                Flint.iff(context.isMobile.get()) && view.el(
                  ["big", 2],
                  { if: context.isMobile.get() },
                  "wants",
                  view.el(["img", 3], { className: "squiggle", src: "/images/enchant-mr-right/squiggle.png" })
                ),
                view.el(
                  ["headerNormSize", 2],
                  null,
                  "not the guy she settles for"
                )
              )
            ),
            view.el(
              ["mainPitch", 1],
              null,
              view.el(
                ["Link", 1],
                { className: "emrBookLink",
                  to: "http://spellboundformula.com/",
                  target: "_blank"
                },
                view.el(["img", 4], { className: "emrBookImg", src: "/images/enchant-mr-right/enchant-mr-right-book.png" })
              ),
              view.el(
                ["rightSection", 1],
                null,
                view.el(
                  ["listPitch", 1],
                  null,
                  view.el(
                    ["listHeading", 1],
                    null,
                    "You'll learn how to:"
                  ),
                  view.el(
                    ["ul", 1],
                    null,
                    view.el(
                      ["li", 1],
                      null,
                      view.el(
                        ["white", 1],
                        null,
                        "Make him ask you out"
                      )
                    ),
                    view.el(
                      ["li", 2],
                      null,
                      view.el(
                        ["white", 2],
                        null,
                        "Get his interest and keep it"
                      )
                    ),
                    view.el(
                      ["li", 3],
                      null,
                      view.el(
                        ["white", 3],
                        null,
                        "Have him chase you"
                      )
                    ),
                    view.el(
                      ["li", 4],
                      null,
                      view.el(
                        ["white", 4],
                        null,
                        "Reject guys you don't like"
                      )
                    )
                  )
                ),
                view.el(
                  ["Link", 2],
                  { className: "goButtonOne",
                    to: "http://spellboundformula.com/",
                    target: "_blank",
                    onHover: function (e) {
                      return buttonOneHover.set(e.hovering);
                    }
                  },
                  "Buy Now"
                )
              )
            ),
            view.el(
              ["offerSection", 1],
              null,
              view.el(
                ["osHeadline", 1],
                null,
                "and a",
                view.el(
                  ["limited", 1],
                  null,
                  view.el(
                    ["span", 1],
                    null,
                    " limited "
                  ),
                  view.el(["img", 5], { className: "squiggletwo", src: "/images/enchant-mr-right/squiggle.png" })
                ),
                "time offer..."
              ),
              view.el(
                ["offerPitch", 1],
                null,
                view.el(
                  ["opTopLine", 1],
                  null,
                  "4 ",
                  view.el(
                    ["i", 1],
                    null,
                    "amazing"
                  ),
                  " additional books to put your"
                ),
                view.el(
                  ["opBottomLine", 1],
                  null,
                  view.el(
                    ["opNormSize", 1],
                    null,
                    "knowledge into action completely "
                  ),
                  view.el(
                    ["free", 1],
                    null,
                    view.el(
                      ["span", 2],
                      null,
                      "free"
                    ),
                    view.el(["img", 6], { className: "squigglethree", src: "/images/enchant-mr-right/squiggle.png" })
                  )
                )
              )
            ),
            view.el(
              ["bonusBooksSection", 1],
              null,
              view.el(
                ["bonusBook", 1],
                null,
                view.el(["img", 7], { className: "bonusBookImg", src: "/images/enchant-mr-right/how-to-talk-to-hot-guys-book.png" }),
                view.el(
                  ["bonusBookInfo", 1],
                  null,
                  view.el(
                    ["bonusBookTitle", 1],
                    null,
                    view.el(
                      ["i", 2],
                      null,
                      "How to Talk to Hot Guys"
                    )
                  ),
                  view.el(
                    ["bonusBookDescription", 1],
                    null,
                    "Learn how to tease and have a fun conversation so you'll stick in his mind."
                  )
                )
              ),
              view.el(
                ["bonusBook", 2],
                null,
                view.el(["img", 8], { className: "bonusBookImg", src: "/images/enchant-mr-right/texting-book.png" }),
                view.el(
                  ["bonusBookInfo", 2],
                  null,
                  view.el(
                    ["bonusBookTitle", 2],
                    null,
                    view.el(
                      ["i", 3],
                      null,
                      "Texting"
                    )
                  ),
                  view.el(
                    ["bonusBookDescription", 2],
                    null,
                    "Romance in 2016 lives on the phone. Learn how to use your most powerful tool to your advantage."
                  )
                )
              ),
              view.el(
                ["bonusBook", 3],
                null,
                view.el(["img", 9], { className: "bonusBookImg", src: "/images/enchant-mr-right/age-defying-secrets-book.png" }),
                view.el(
                  ["bonusBookInfo", 3],
                  null,
                  view.el(
                    ["bonusBookTitle", 3],
                    null,
                    view.el(
                      ["i", 4],
                      null,
                      "Age-defying Secrets"
                    )
                  ),
                  view.el(
                    ["bonusBookDescription", 3],
                    null,
                    "Learn how to present a cool personality that guys find irresistable no matter what your age."
                  )
                )
              ),
              view.el(
                ["bonusBook", 4],
                null,
                view.el(["img", 10], { className: "bonusBookImg", src: "/images/enchant-mr-right/screening-book.png" }),
                view.el(
                  ["bonusBookInfo", 4],
                  null,
                  view.el(
                    ["bonusBookTitle", 4],
                    null,
                    view.el(
                      ["i", 5],
                      null,
                      "Screening"
                    )
                  ),
                  view.el(
                    ["bonusBookDescription", 4],
                    null,
                    "Learn how to attract the guys you actually want and keep away the guys you dislike."
                  )
                )
              )
            ),
            view.el(
              ["bottomSection", 1],
              null,
              view.el(
                ["bsHeadline", 1],
                null,
                "Invest in your future happiness",
                view.el(
                  ["i", 6],
                  null,
                  " today"
                )
              ),
              view.el(["img", 11], { className: "bookAll", src: "/images/enchant-mr-right/whole-product.png" }),
              view.el(
                ["Link", 3],
                { className: "goButtonTwo",
                  to: "http://spellboundformula.com/",
                  target: "_blank",
                  onHover: function (e) {
                    return buttonTwoHover.set(e.hovering);
                  }
                },
                "Buy Now"
              )
            )
          ),
          view.el(["Footer", 1], null)
        );
      });

      "13669ad6";

      $["emrPage"] = function (_, _index) {
        return {
          width: context.width.get(),
          borderRadius: context.isMobile.get() ? 0 : 12 };
      };

      $["enchantLogo"] = function (_, _index) {
        return {
          width: Math.max(320, context.width.get() * .6),
          height: 465 / 1316 * Math.max(320, context.width.get() * .6),
          padding: context.isMobile.get() ? [15, 10] : [25, 0]
        };
      };

      "6bc33b8e";

      $["page"] = function (_, _index) {
        return {
          background: 'linear-gradient(to bottom, ' + 'rgb(119, 67, 149) 0%, rgb(160, 88, 180) 100%)',
          width: context.width.get(), marginBottom: context.isMobile.get() ? 20 : 50,
          borderRadius: context.isMobile.get() ? 0 : 12 };
      };

      "461f98ba";

      $["header"] = function (_, _index) {
        return {
          fontSize: context.isMobile.get() ? 14 : 28, marginTop: context.isMobile.get() ? 15 : 25 };
      };

      $["headerTopLine"] = function (_, _index) {
        return {
          flexDirection: context.isMobile.get() ? 'column' : 'row'
        };
      };

      "4cb1874b";
      "7affce55";
      "254eccb4";

      $["big"] = function (_, _index) {
        return {
          fontSize: context.isMobile.get() ? 21 : 36, width: context.isMobile.get() ? 65 : 112, height: context.isMobile.get() ? 0 : 10,
          alignSelf: context.isMobile.get() ? 'flex-start' : 'flex-start',
          paddingTop: context.isMobile.get() ? 2 : 9
        };
      };

      $["squiggle"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? 60 : 112
        };
      };

      "eabaa944";

      $["mainPitch"] = function (_, _index) {
        return {
          flexDirection: context.isMobile.get() ? 'column' : 'row', alignItems: context.isMobile.get() ? 'center' : 'flex-start',
          width: context.isMobile.get() ? context.width.get() : '100%' };
      };

      "3208a4f1";

      $["emrBookImg"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? 200 : context.width.get() * .36,
          height: 852 / 500 * (context.isMobile.get() ? 200 : context.width.get() * .36),
          paddingLeft: context.isMobile.get() ? context.width.get() * .03 : 0 };
      };

      "745b2c04";

      $["listHeading"] = function (_, _index) {
        return { fontSize: Math.max(16, .02 * context.width.get()),
          alignSelf: context.isMobile.get() ? 'center' : 'flex-start'
        };
      };

      "0de9f28e";

      $["ul"] = function (_, _index) {
        return {
          fontSize: Math.max(14, .023 * context.width.get()) };
      };

      "3e81579c";
      "3e81579c";

      $["rightSection"] = function (_, _index) {
        return { marginLeft: context.isMobile.get() ? 0 : 5,
          marginTop: context.isMobile.get() ? 15 : context.width.get() * .1,
          marginRight: context.isMobile.get() ? 20 : 0
        };
      };

      "3c8faaca";

      $["goButton"] = function (_, _index) {
        return {
          marginTop: .03 * context.width.get(),
          marginBottom: .07 * context.width.get(),
          width: Math.max(220, .25 * context.width.get()),
          height: Math.max(74.8, .085 * context.width.get()),
          background: 'linear-gradient(to bottom, ' + 'rgb(254, 70, 117) 0%, rgb(202, 47, 79) 100%)', fontSize: Math.max(16, .023 * context.width.get()), alignSelf: context.isMobile.get() ? 'center' : 'flex-start'
        };
      };

      "28353894";

      $["osHeadline"] = function (_, _index) {
        return {
          fontSize: Math.max(16, .03 * context.width.get()) };
      };

      "28353894";

      $["squiggletwo"] = function (_, _index) {
        return {
          width: Math.max(60, .105 * context.width.get()) };
      };

      "4f56a859";

      $["offerPitch"] = function (_, _index) {
        return {
          paddingTop: context.isMobile.get() ? 30 : 50, fontSize: context.isMobile.get() ? 14 : 28 };
      };

      "4f56a859";
      "4f56a859";

      $["squigglethree"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? 50 : 90
        };
      };

      "4f56a859";
      "7de185da";

      $["free"] = function (_, _index) {
        return {
          fontSize: context.isMobile.get() ? 24 : 44, paddingTop: context.isMobile.get() ? 1 : 2 };
      };

      "778897fb";

      $["bonusBook"] = function (_, _index) {
        return {
          flexDirection: context.isMobile.get() ? 'column' : 'row',
          alignSelf: context.isMobile.get() ? 'center' : 'flex-start'
        };
      };

      $["bonusBookImg"] = function (_, _index) {
        return {
          maxWidth: Math.max(150, context.width.get() * .2),
          maxHeight: 67 / 44 * Math.max(150, context.width.get() * .2),
          alignSelf: context.isMobile.get() ? 'center' : 'flex-start'
        };
      };

      "76401977";

      $["bonusBookInfo"] = function (_, _index) {
        return { marginBottom: context.isMobile.get() ? 30 : 70
        };
      };

      "f8095636";

      $["bonusBookTitle"] = function (_, _index) {
        return {
          fontSize: context.isMobile.get() ? 16 : 22, alignSelf: context.isMobile.get() ? 'center' : 'flex-start'
        };
      };

      "3753538d";

      $["bonusBookDescription"] = function (_, _index) {
        return { fontSize: context.isMobile.get() ? 14 : 16,
          alignItems: context.isMobile.get() ? 'center' : 'flex-start',
          textAlign: context.isMobile.get() ? 'center' : 'left' };
      };

      "724f4f81";
      "e5c6be04";

      $["bsHeadline"] = function (_, _index) {
        return { fontSize: Math.max(17, context.width.get() * .04) };
      };

      "e5c6be04";

      $["bookAll"] = function (_, _index) {
        return {
          width: Math.max(220, context.width.get() * .5),
          height: 646 / 800 * Math.max(220, context.width.get() * .5) };
      };

      "7734d5fd";

      $["goButtonOne"] = function (_, _index) {
        return {
          marginTop: context.isMobile.get() ? 15 : 0,
          marginBottom: .07 * context.width.get(),
          width: Math.max(220, .25 * context.width.get()),
          height: Math.max(74.8, .085 * context.width.get()),
          background: buttonOneHover.get() ? 'linear-gradient(to bottom, ' + 'pink 0%, rgb(202, 47, 79) 100%)' : 'linear-gradient(to bottom, ' + 'rgb(254, 70, 117) 0%, rgb(202, 47, 79) 100%)', fontSize: Math.max(16, .023 * context.width.get()) };
      };

      "7734d5fd";

      $["goButtonTwo"] = function (_, _index) {
        return {
          marginTop: context.isMobile.get() ? 15 : 0,
          marginBottom: .07 * context.width.get(),
          width: Math.max(220, .25 * context.width.get()),
          height: Math.max(74.8, .085 * context.width.get()),
          background: buttonTwoHover.get() ? 'linear-gradient(to bottom, ' + 'pink 0%, rgb(202, 47, 79) 100%)' : 'linear-gradient(to bottom, ' + 'rgb(254, 70, 117) 0%, rgb(202, 47, 79) 100%)', fontSize: Math.max(16, .023 * context.width.get()) };
      };
    });
  })
})();
//# sourceMappingURL=emrPage.js.map
